import { SortDescriptor } from '@progress/kendo-data-query'
import {
  DividendPaymentFilterKey,
  DividendPaymentKey,
} from 'api/Trading-Accounts/Types/DividendsDto'

export const normalizeDividendSortQuery = (sortDescriptors: SortDescriptor[]): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === DividendPaymentKey.brokerSymbol)
        return { ...x, field: DividendPaymentFilterKey.brokerSymbol }
      if (x.field === DividendPaymentKey.companyName)
        return { ...x, field: DividendPaymentFilterKey.companyName }
      if (x.field === DividendPaymentKey.amount)
        return { ...x, field: DividendPaymentFilterKey.amount }
      if (x.field === DividendPaymentKey.declarationDate)
        return { ...x, field: DividendPaymentFilterKey.declarationDate }
      if (x.field === DividendPaymentKey.exDividendDate)
        return { ...x, field: DividendPaymentFilterKey.exDividendDate }
      if (x.field === DividendPaymentKey.paymentDate)
        return { ...x, field: DividendPaymentFilterKey.paymentDate }
      if (x.field === DividendPaymentKey.currency)
        return { ...x, field: DividendPaymentFilterKey.currency }
      if (x.field === DividendPaymentKey.dividendType)
        return { ...x, field: DividendPaymentFilterKey.dividendType }
      return x
    })
    .filter((x) => !!x)
